<template>
  <div>
    <van-button @click="show=true" size="small">
      <span v-if="$attrs.value">{{
          $attrs.value[0] | valueName('Warehouse')
        }}-{{ $attrs.value[1] | valueName('WarehousePos') }}</span>
      <span v-else style="color: orange">请选择</span>
    </van-button>
    <van-popup v-model="show" v-bind="$attrs" round position="bottom">
      <van-cascader :options="options"
                    title="请选择仓库/库位"
                    @close="onClose"
                    @finish="onFinish">
      </van-cascader>
    </van-popup>
  </div>
</template>

<script>
import { Cascader, Button, Popup } from 'vant'

export default {
  name: 'WxWarehouseSelect',
  components: {
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
    [Button.name]: Button
  },
  props: {
    selectAll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: false
    }
  },
  created () {
    this.$store.dispatch('data/kvList', 'WarehouseAndPos')
  },
  methods: {
    convertData (item) {
      const ret = {
        text: item.name,
        value: item.id,
        children: []
      }
      for (const pos of item.posList) {
        ret.children.push({
          text: pos.name,
          value: pos.id
        })
      }
      return ret
    },
    onClose () {
      this.show = false
    },
    onFinish ({ selectedOptions }) {
      selectedOptions = selectedOptions.map(item => item.value)
      this.$emit('input', selectedOptions.length < 2 ? null : selectedOptions)
      this.show = false
    }
  },
  computed: {
    options () {
      const options = []
      if (this.selectAll) {
        options.push({
          text: '全部',
          value: null
        })
      }
      for (const item of this.$store.state.data.WarehouseAndPos || []) {
        options.push(this.convertData(item))
      }
      return options
    }
  }
}
</script>

<style scoped>

</style>
